import GrimoireInterface from "../Interface/GrimoireInterface";
export default class Utility {
    static w(message) {
        if (GrimoireInterface.debug) {
            console.warn(message);
        }
    }
    static isCamelCase(str) {
        return /^[A-Z][a-zA-Z0-9]*$/.test(str);
    }
    static isSnakeCase(str) {
        return /^[a-z0-9\-]+$/.test(str);
    }
    static flat(array) {
        let count = 0;
        for (let i = 0; i < array.length; i++) {
            count += array[i].length;
        }
        const ret = new Array(count);
        count = 0;
        for (let i = 0; i < array.length; i++) {
            const ar = array[i];
            for (let j = 0; j < ar.length; j++) {
                ret[count] = ar[j];
                count++;
            }
        }
        return ret;
    }
    static flatMap(source, map) {
        const c = new Array(source.length);
        for (let i = 0; i < source.length; i++) {
            c[i] = map(source[i]);
        }
        return Utility.flat(c);
    }
    static sum(array) {
        let total = 0;
        for (let i = 0; i < array.length; i++) {
            total += array[i];
        }
        return total;
    }
    static remove(array, target) {
        let index = -1;
        for (let i = 0; i < array.length; i++) {
            if (target === array[i]) {
                index = i;
                break;
            }
        }
        if (index < 0) {
            return false;
        }
        array.splice(index, 1);
        return true;
    }
    /**
     * 重複がなければtrue
     */
    static checkOverlap(array) {
        const list = [];
        for (let i = 0; i < array.length; i++) {
            const item = array[i];
            if (list.indexOf(item) !== -1) {
                return false;
            }
            list.push(item);
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/Base/Utility.ts